<script>
import { toRef } from 'vue'
import { useSeo } from '@/composables/useSeo'

// SeoHead — renderless component wrapping the useSeo composable so pages that
// prefer template usage can declare their SEO metadata declaratively:
//
//   <SeoHead :seo="seo" />
//
// where `seo` is the page's PageSeo model (typically imported from its
// co-located content module). This sets a unique <title> and meta description
// per page (Requirement 10.1) and Open Graph tags for the Home page
// (Requirement 10.2). The component contributes no markup of its own; the
// reactive `seo` prop is forwarded to useSeo, so changing it updates the head.
export default {
  name: 'SeoHead',
  props: {
    // The PageSeo model: { title, description, og?: { title, description, image } }.
    seo: {
      type: Object,
      required: true,
    },
  },
  setup (props) {
    // Pass a reactive reference so head updates track prop changes.
    useSeo(toRef(props, 'seo'))
    return {}
  },
  // Renderless: contribute nothing to the DOM.
  render () {
    return null
  },
}
</script>
